// extracted by mini-css-extract-plugin
export default {"h4":"vp_Ni3mV","marginNone":"vp_mfeJL"};